import React, { useEffect, useState } from 'react';
import { tryFetch } from '../../../Helpers/FetchAPI';
import '../../../styles/mpMerchantReview.scss'

interface Props {
  merchantId: string;
}

interface MerchantReview {
  id: string;
  average_rating: string;
}

export default function MerchantReview({ merchantId }: Props) {
  const [reviewData, setReviewData] = useState<MerchantReview | null>(null);

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const response = await tryFetch({
          url: `/merchant/${merchantId}/reviews`,
          method: 'GET',
        });

        if (response.is_success && response.data) {
          setReviewData(response.data as MerchantReview);
        } else {
          console.error('Failed to fetch merchant review:', response.error);
        }
      } catch (err) {
        console.error('Error fetching review:', err);
      }
    };

    if (merchantId) fetchReview();
  }, [merchantId]);

  if (!reviewData) return null;

  const rating = parseFloat(reviewData.average_rating);
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

   return (
    <div className="mp-merchant-rating">
      {[...Array(fullStars)].map((_, i) => (
        <span key={`full-${i}`} className="star full">★</span>
      ))}
      {hasHalfStar && <span className="star half">★</span>}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={`empty-${i}`} className="star empty">★</span>
      ))}
      <span className="rating-value">{rating.toFixed(1)} / 5.0</span>
    </div>
  );
}

//   return (
//     <div className="mp-merchant-rating">
//       <span>★ {parseFloat(reviewData.average_rating).toFixed(1)} / 5</span>
//     </div>
//   );
// }
